/**
 * Auto-generated API Client
 *
 * Generated by @spfn/core codegen
 * DO NOT EDIT MANUALLY
 *
 * @generated 2025-11-03T13:40:07.038Z
 */

import { client } from '@spfn/core/client';
import type { InferContract } from '@spfn/core';

import { getAdminLabelContract } from '@/lib/contracts/labels';

// ============================================
// Types
// ============================================

export type GetAdminLabelResponse = InferContract<typeof getAdminLabelContract>['response'];
export type GetAdminLabelParams = InferContract<typeof getAdminLabelContract>['params'];

// ============================================
// API Functions
// ============================================

/**
 * GET /_cms/labels/:labelId/admin
 */
export const getAdminLabel = (options: { params: GetAdminLabelParams }) => client.call(getAdminLabelContract, options);

